import { CENTS_PER_DOLLAR } from './constants/currency';

export const formatNumber = (num: number): string => {
  return new Intl.NumberFormat().format(num / CENTS_PER_DOLLAR);
};
